import { CountryEndpoints } from '@/modules/seller-management/country/api/countryEndpoint'

/**
 * Country endpoint instance
 * instantiate Country api class with different api path
 */

export const countryEndpoints = new CountryEndpoints()
